import * as React from 'react';
import { IconProps } from '../types';

const IcAddress = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='24' viewBox='0 0 20 24' fill='none' {...props}>
    <path
      d='M9.93088 0C4.99601 0 7.59067e-05 4.0164 7.59067e-05 8.95329C7.59067e-05 16.3089 9.04005 23.4911 9.38316 23.7933C9.53977 23.9311 9.73524 24.0001 9.93088 24.0001C10.1265 24.0001 10.3221 23.9312 10.4786 23.7933C10.8215 23.4911 19.9542 16.309 19.9542 8.95329C19.9542 4.0164 14.8657 0 9.93088 0ZM9.93088 22.0355C8.14914 20.3089 1.65745 14.518 1.65745 8.95329C1.65745 4.93034 5.90987 1.65737 9.93088 1.65737C13.9519 1.65737 18.2968 4.93034 18.2968 8.95329C18.2968 14.5179 11.7126 20.3088 9.93088 22.0355Z'
      fill={props.fill || '#1D2129'}
    />
    <path
      d='M12.1471 8.77264C12.1471 7.54895 11.155 6.55689 9.93134 6.55686C8.70763 6.55686 7.71555 7.54893 7.71555 8.77264C7.71558 9.99633 8.70765 10.9884 9.93134 10.9884V12.4884L9.73993 12.4835C7.84015 12.3872 6.31689 10.8638 6.22046 8.96405L6.21558 8.77264C6.21558 6.72052 7.87921 5.05688 9.93134 5.05688L10.1227 5.06177C12.0859 5.16141 13.6471 6.78474 13.6471 8.77264L13.6422 8.96405C13.5426 10.9272 11.9192 12.4884 9.93134 12.4884V10.9884C11.155 10.9884 12.1471 9.99631 12.1471 8.77264Z'
      fill={props.fill || '#1D2129'}
    />
  </svg>
);

export default IcAddress;
